import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip } from "recharts";

export default function MessageStatsWidget({ data }) {
  if (!data) return null;
  const { today, overall, dailyTrend, avgResponseTime } = data;

  return (
    <Paper className="glass-card" sx={{ p: 3 }}>
      <Typography fontWeight={700} fontSize={15} color="#1e293b" mb={2}>Message Stats</Typography>
      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, mb: 2 }}>
        <StatBox icon={<CallReceivedIcon sx={{ fontSize: 18, color: "#3b82f6" }} />} label="Received Today" value={today.received} />
        <StatBox icon={<SendIcon sx={{ fontSize: 18, color: "#8b5cf6" }} />} label="Bot Sent" value={today.sent} />
        <StatBox icon={<SupportAgentIcon sx={{ fontSize: 18, color: "#10b981" }} />} label="Agent Replies" value={today.agentMessages} />
        <StatBox icon={<AccessTimeIcon sx={{ fontSize: 18, color: "#f59e0b" }} />} label="Avg Response" value={avgResponseTime > 60 ? `${Math.round(avgResponseTime / 60)}m` : `${avgResponseTime}s`} />
      </Box>
      {dailyTrend && dailyTrend.length > 0 && (
        <Box sx={{ height: 120, mt: 1 }}>
          <Typography variant="caption" color="#64748b" fontWeight={600} mb={0.5}>7-Day Trend</Typography>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={dailyTrend}>
              <XAxis dataKey="date" tick={{ fontSize: 10 }} tickFormatter={d => d.slice(5)} />
              <YAxis hide />
              <Tooltip />
              <Bar dataKey="count" fill="#6366f1" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </Box>
      )}
      <Box sx={{ mt: 1.5, pt: 1.5, borderTop: "1px solid #e2e8f0" }}>
        <Typography variant="caption" color="#64748b">Lifetime: <strong>{overall.totalMessages}</strong> messages ({overall.agentMessages} agent, {overall.customerMessages} customer)</Typography>
      </Box>
    </Paper>
  );
}

function StatBox({ icon, label, value }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, p: 1.5, borderRadius: 2, bgcolor: "rgba(99,102,241,0.06)" }}>
      {icon}
      <Box>
        <Typography variant="caption" color="#64748b" fontWeight={600} display="block">{label}</Typography>
        <Typography fontWeight={700} fontSize={16} color="#1e293b">{value}</Typography>
      </Box>
    </Box>
  );
}
